import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import BoardActions from '../components/BoardActions';
import canEditBoardContent, { canManageBoardMemberships } from '../utils/can-edit-board-content';

const mapStateToProps = (state) => {
  const allUsers = selectors.selectUsers(state);
  const isCurrentUserManager = selectors.selectIsCurrentUserManagerForCurrentProject(state);
  const memberships = selectors.selectMembershipsForCurrentBoard(state);
  const labels = selectors.selectLabelsForCurrentBoard(state);
  const filterUsers = selectors.selectFilterUsersForCurrentBoard(state);
  const filterLabels = selectors.selectFilterLabelsForCurrentBoard(state);
  const currentUserMembership = selectors.selectCurrentUserMembershipForCurrentBoard(state);
  const currentUser = selectors.selectCurrentUser(state);
  const currentProject = selectors.selectCurrentProject(state);
  const currentBoard = selectors.selectCurrentBoard(state);
  const config = selectors.selectConfig(state);
  const superuserIds = Array.isArray(config?.superuserIds) ? config.superuserIds : [];
  const isSuperuser = currentUser?.id && superuserIds.map(String).includes(String(currentUser.id));
  const pointSystem = selectors.selectBoardLevelPointSystemForCurrentBoard(state);
  const contentTypeTemplates = selectors.selectContentTypeTemplates(state);

  return {
    memberships,
    labels,
    filterUsers,
    filterLabels,
    allUsers,
    canEdit: canEditBoardContent(currentUser, currentUserMembership),
    canEditMemberships: canManageBoardMemberships(
      currentUser,
      currentUserMembership,
      isCurrentUserManager,
    ),
    canManagePointSystem: !!(isSuperuser || currentUser?.isAdmin || currentUser?.isSAdmin),
    boardId: currentBoard ? currentBoard.id : null,
    isPointSystemEnabled: currentBoard?.isPointSystemEnabled === true,
    pointSystem,
    contentTypeTemplates,
    background: currentProject ? currentProject.background : null,
    backgroundImageUrl:
      currentProject && currentProject.backgroundImage
        ? currentProject.backgroundImage.url
        : null,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onMembershipCreate: entryActions.createMembershipInCurrentBoard,
      onMembershipUpdate: entryActions.updateBoardMembership,
      onMembershipDelete: entryActions.deleteBoardMembership,
      onUserToFilterAdd: entryActions.addUserToFilterInCurrentBoard,
      onUserFromFilterRemove: entryActions.removeUserFromFilterInCurrentBoard,
      onLabelToFilterAdd: entryActions.addLabelToFilterInCurrentBoard,
      onLabelFromFilterRemove: entryActions.removeLabelFromFilterInCurrentBoard,
      onLabelCreate: entryActions.createLabelInCurrentBoard,
      onLabelUpdate: entryActions.updateLabel,
      onLabelMove: entryActions.moveLabel,
      onLabelDelete: entryActions.deleteLabel,
      onPointSystemEnabledSet: entryActions.updatePointSystemInCurrentBoard,
      onPointSystemModalOpen: entryActions.openPointSystemModalInCurrentBoard,
      onContentTypeTemplatesFetch: entryActions.fetchContentTypeTemplates,
      onContentTypeTemplateApply: entryActions.applyContentTypeTemplateInCurrentBoard,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(BoardActions);
